import React from 'react';
import Icon from '../../../components/AppIcon';
import StatusIndicator from '../../../components/ui/StatusIndicator';

const QueueOverviewPanel = ({ 
  totalInvoices = 0, 
  processingCount = 0, 
  completedCount = 0, 
  errorCount = 0,
  activeBatches = 0 
}) => {
  const stats = [
    {
      label: 'Total Invoices',
      value: totalInvoices,
      icon: 'FileText',
      color: 'text-foreground',
      bgColor: 'bg-muted'
    },
    {
      label: 'Processing',
      value: processingCount,
      icon: 'Clock',
      color: 'text-accent',
      bgColor: 'bg-accent/10'
    },
    {
      label: 'Completed',
      value: completedCount,
      icon: 'CheckCircle',
      color: 'text-success',
      bgColor: 'bg-success/10'
    },
    {
      label: 'Errors',
      value: errorCount,
      icon: 'AlertCircle',
      color: 'text-error',
      bgColor: 'bg-error/10'
    }
  ];

  const completionRate = totalInvoices > 0 ? ((completedCount / totalInvoices) * 100)?.toFixed(1) : 0;

  return (
    <div className="bg-muted border border-border rounded-lg p-6 shadow-sm">
      <div className="flex items-center justify-between mb-6">
        <div className="flex items-center space-x-3">
          <div className="flex items-center justify-center w-10 h-10 bg-gradient-to-br from-primary to-accent rounded-lg">
            <Icon name="Activity" size={20} color="white" strokeWidth={2} />
          </div>
          <div>
            <h2 className="text-lg font-semibold text-foreground">Queue Overview</h2>
            <p className="text-sm text-muted-foreground">Real-time processing status</p>
          </div>
        </div>
        
        <div className="flex items-center space-x-4">
          <StatusIndicator 
            status={processingCount > 0 ? 'processing' : 'idle'}
            count={activeBatches}
            label="Active Batches"
            size="sm"
          />
          <div className="text-right">
            <div className="text-2xl font-bold text-foreground">{completionRate}%</div>
            <div className="text-xs text-muted-foreground">Completion Rate</div>
          </div>
        </div>
      </div>
      {/* Statistics Grid */}
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 mb-6">
        {stats?.map((stat, index) => (
          <div key={index} className={`
            flex items-center space-x-3 p-4 rounded-lg border border-border
            ${stat?.bgColor} transition-all duration-150 hover:scale-102
          `}>
            <div className={`
              flex items-center justify-center w-10 h-10 rounded-lg
              ${stat?.bgColor} ${stat?.color}
            `}>
              <Icon name={stat?.icon} size={18} color="currentColor" strokeWidth={2} />
            </div>
            <div>
              <div className={`text-2xl font-bold ${stat?.color}`}>
                {stat?.value?.toLocaleString()}
              </div>
              <div className="text-xs text-muted-foreground font-medium">
                {stat?.label}
              </div>
            </div>
          </div>
        ))}
      </div>
      {/* Progress Bar */}
      <div className="space-y-2">
        <div className="flex items-center justify-between text-sm">
          <span className="text-muted-foreground">Overall Progress</span>
          <span className="text-foreground font-medium">{completedCount} of {totalInvoices}</span>
        </div>
        <div className="w-full bg-muted rounded-full h-2 overflow-hidden">
          <div 
            className="h-full bg-gradient-to-r from-primary to-accent transition-all duration-500 ease-out"
            style={{ width: `${completionRate}%` }}
          />
        </div>
      </div>
    </div>
  );
};

export default QueueOverviewPanel;

